<template>
  <div>
    <h3 class="title-type-5">
      이미지 광고 세부 조건
      <span class="required">
        <v-icon>mdi-check-circle-outline</v-icon>
        필수
      </span>
    </h3>
    <ul class="form-row-2 four-text-field-list">
      <li>
        <v-text-field
          class="input-custom-2"
          label="가로(px)"
          v-model="width"
          :rules="[rules.required, rules.isNumber]"
          outlined
        />
      </li>
      <li>
        <v-text-field
          class="input-custom-2"
          label="세로(px)"
          v-model="height"
          :rules="[rules.required, rules.isNumber]"
          outlined
        />
      </li>
      <li>
        <div class="d-flex">
          <v-text-field
            class="input-custom-2"
            label="용량"
            v-model="size"
            :rules="[rules.required, rules.isNumber]"
            outlined
          />
          <v-select
            :items="sizeUnitItems"
            class="input-custom-2"
            placeholder="단위"
            v-model="sizeUnit"
            :rules="[rules.required]"
            style="width: 40%; min-width: 40%; font-size: 12px"
            outlined
            append-icon=""
          />
        </div>
      </li>
      <li>
        <v-text-field
          class="input-custom-2"
          label="확장자"
          v-model="extension"
          :rules="[rules.required, rules.checkExtension]"
          outlined
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { isAllowExtension } from '@/utils/validation';

export default {
  props: {
    propCondition: Object,
  },
  data: () => ({
    size: null,
    sizeUnit: null,
    width: null,
    height: null,
    extension: null,
    rules: {
      required: v => !!v || '필수 항목입니다.',
      maxLength: length => {
        return v =>
          (!!v && v.length <= length) || `최대 ${length}자까지 가능합니다.`;
      },
      isNumber: v => (!!v && /^[0-9]+$/.test(v)) || '숫자만 가능합니다.',
      checkExtension: v => {
        if (!v) return true;

        const message = e => `${e} 확장자는 허용되지 않는 확장자입니다.`;
        const extensions = v.split(',');
        for (const e of extensions) {
          if (!isAllowExtension('image', e)) {
            return message(e);
          }
        }
        return true;
      },
    },
    sizeUnitItems: ['KB', 'MB', 'GB'],
  }),
  methods: {
    getValues() {
      return {
        size: this.size ? this.size * 1 : null,
        sizeUnit: this.sizeUnit ? this.sizeUnit : null,
        width: this.width ? this.width * 1 : null,
        height: this.height ? this.height * 1 : null,
        extension: this.extension ? this.extension.split(',') : null,
      };
    },
  },
  created() {
    if (this.propCondition) {
      this.width = this.propCondition.width;
      this.height = this.propCondition.height;
      this.size = this.propCondition.size;
      this.sizeUnit = this.propCondition.sizeUnit;
      this.extension = this.propCondition.extension
        ? this.propCondition.extension.join(',')
        : null;
    }
  },
};
</script>

<style scoped>
.four-text-field-list > li {
  width: 24%;
  padding-right: 1%;
}
.v-select.v-text-field--outlined:not(.v-text-field--single-line)
  :deep(.v-select__selections) {
  padding: 0px;
}
</style>
